module.exports = __webpack_public_path__ + "img/bg-audio-2.d7e6a8cd.png";